/**
 * Generated by scripts/generate-team-identity.ts from ESPN's public team lists. Do not edit by
 * hand: re-run the script and review the diff. Hand-written names go in teamIdentityManual.ts.
 */

import type { LeagueKey } from './league';

export const GENERATED_TEAM_NAMES: Partial<Record<LeagueKey, Record<string, readonly string[]>>> = {
  basketball_nba: {
    ATL: ['ATL Hawks', 'Hawks'],
    BKN: ['BKN Nets', 'Nets'],
    BOS: ['BOS Celtics', 'Celtics'],
    CHA: ['CHA Hornets', 'Hornets'],
    CHI: ['CHI Bulls', 'Bulls'],
    CLE: ['CLE Cavaliers', 'Cavaliers'],
    DAL: ['DAL Mavericks', 'Mavericks'],
    DEN: ['DEN Nuggets', 'Nuggets'],
    DET: ['DET Pistons', 'Pistons'],
    GSW: ['GS', 'GS Warriors', 'Warriors'],
    HOU: ['HOU Rockets', 'Rockets'],
    IND: ['IND Pacers', 'Pacers'],
    LAC: ['LA Clippers', 'LAC Clippers', 'Clippers'],
    LAL: ['LAL Lakers', 'Lakers'],
    MEM: ['MEM Grizzlies', 'Grizzlies'],
    MIA: ['MIA Heat', 'Heat'],
    MIL: ['MIL Bucks', 'Bucks'],
    MIN: ['MIN Timberwolves', 'Timberwolves'],
    NOP: ['NO', 'NO Pelicans', 'Pelicans'],
    NYK: ['NY', 'NY Knicks', 'Knicks'],
    OKC: ['OKC Thunder', 'Thunder'],
    ORL: ['ORL Magic', 'Magic'],
    PHI: ['PHI 76ers', '76ers'],
    PHX: ['PHX Suns', 'Suns'],
    POR: ['POR Trail Blazers', 'Trail Blazers'],
    SAC: ['SAC Kings', 'Kings'],
    SAS: ['SA', 'SA Spurs', 'Spurs'],
    TOR: ['TOR Raptors', 'Raptors'],
    UTA: ['UTAH', 'Jazz'],
    WAS: ['WSH', 'WSH Wizards', 'Wizards'],
  },
  basketball_wnba: {
    ATL: ['ATL Dream', 'Dream'],
    CHI: ['CHI Sky', 'Sky'],
    CON: ['CON Sun', 'Sun'],
    DAL: ['DAL Wings', 'Wings'],
    GVV: ['GS', 'GS Valkyries', 'Valkyries'],
    IND: ['IND Fever', 'Fever'],
    LAS: ['LA', 'LA Sparks', 'Sparks'],
    LVA: ['LV', 'LV Aces', 'Aces'],
    MIN: ['MIN Lynx', 'Lynx'],
    NYL: ['NY', 'NY Liberty', 'Liberty'],
    PHO: ['PHX', 'PHX Mercury', 'Mercury'],
    POR: ['POR Fire', 'Fire'],
    SEA: ['SEA Storm', 'Storm'],
    TOR: ['TOR Tempo', 'Tempo'],
    WSH: ['WSH Mystics', 'Mystics'],
  },
  basketball_ncaab: {
    AAMU: ['Alabama A&M Bulldogs', 'AAMU Bulldogs'],
    ACU: [
      'Abilene Christian Wildcats',
      'Abilene Chrstn',
      'Abilene Chrstn Wildcats',
      'ACU Wildcats',
    ],
    AF: ['Air Force Falcons', 'AF Falcons'],
    AKR: ['Akron Zips', 'AKR Zips'],
    ALA: ['Alabama Crimson Tide', 'ALA Crimson Tide'],
    ALCN: ['Alcorn State Braves', 'ALCN Braves'],
    ALST: ['Alabama State Hornets', 'ALST Hornets'],
    AMCC: [
      'Texas A&M-Corpus Christi Islanders',
      'Texas A&M-CC',
      'Texas A&M-CC Islanders',
      'AMCC Islanders',
    ],
    AMER: ['American University Eagles', 'American', 'American Eagles', 'AMER Eagles'],
    APP: ['App State Mountaineers', 'APP Mountaineers'],
    APSU: ['Austin Peay Governors', 'APSU Governors'],
    ARIZ: ['Arizona Wildcats', 'ARIZ Wildcats'],
    ARK: ['Arkansas Razorbacks', 'ARK Razorbacks'],
    ARMY: ['Army Black Knights'],
    ARST: ['Arkansas State Red Wolves', 'ARST Red Wolves'],
    ASU: ['Arizona State Sun Devils', 'ASU Sun Devils'],
    AUB: ['Auburn Tigers', 'AUB Tigers'],
    BALL: ['Ball State Cardinals', 'BALL Cardinals'],
    BAY: ['Baylor Bears', 'BAY Bears'],
    BC: ['Boston College Eagles', 'BC Eagles'],
    BCU: ['Bethune-Cookman Wildcats', 'Bethune', 'Bethune Wildcats', 'BCU Wildcats'],
    BEL: ['Belmont Bruins', 'BEL Bruins'],
    BELL: ['Bellarmine Knights', 'BELL Knights'],
    BGSU: ['Bowling Green Falcons', 'BGSU Falcons'],
    BING: ['Binghamton Bearcats', 'BING Bearcats'],
    BOIS: ['Boise State Broncos', 'BOIS Broncos'],
    BRAD: ['Bradley Braves', 'BRAD Braves'],
    BRWN: ['Brown Bears', 'BRWN Bears'],
    BRY: ['Bryant Bulldogs', 'BRY Bulldogs'],
    BU: ['Boston University Terriers', 'Boston U', 'Boston U Terriers', 'BU Terriers'],
    BUCK: ['Bucknell Bison', 'BUCK Bison'],
    BUF: ['Buffalo Bulls', 'BUF Bulls'],
    BUT: ['Butler Bulldogs', 'BTLR', 'BTLR Bulldogs'],
    BYU: ['BYU Cougars'],
    CAL: ['California Golden Bears', 'CAL Golden Bears'],
    CAM: ['Campbell Fighting Camels', 'CAM Fighting Camels'],
    CAN: ['Canisius Golden Griffins', 'CAN Golden Griffins'],
    CARK: ['Central Arkansas Bears', 'C Arkansas', 'C Arkansas Bears', 'CARK Bears'],
    CBU: ['California Baptist Lancers', 'CA Baptist', 'CA Baptist Lancers', 'CBU Lancers'],
    CCSU: [
      'Central Connecticut Blue Devils',
      'C Connecticut',
      'C Connecticut Blue Devils',
      'CCSU Blue Devils',
    ],
    CCU: ['Coastal Carolina Chanticleers', 'Coastal', 'Coastal Chanticleers', 'CCU Chanticleers'],
    CHSO: [
      'Charleston Southern Buccaneers',
      'Charleston So',
      'Charleston So Buccaneers',
      'CHSO Buccaneers',
    ],
    CHST: ['Chicago State Cougars', 'CHST Cougars'],
    CIN: ['Cincinnati Bearcats', 'CIN Bearcats'],
    CIT: ['The Citadel Bulldogs', 'CIT Bulldogs'],
    CLE: ['Cleveland State Vikings', 'CLE Vikings'],
    CLEM: ['Clemson Tigers', 'CLEM Tigers'],
    CLT: ['Charlotte 49ers', 'CLT 49ers'],
    CMU: ['Central Michigan Chippewas', 'C Michigan', 'C Michigan Chippewas', 'CMU Chippewas'],
    COFC: ['Charleston Cougars', 'COFC Cougars'],
    COLG: ['Colgate Raiders', 'COLG Raiders'],
    COLO: ['Colorado Buffaloes', 'COLO Buffaloes'],
    COLU: ['Columbia Lions', 'COLU Lions'],
    CONN: ['UConn Huskies', 'CONN Huskies'],
    COPP: ['Coppin State Eagles', 'COPP Eagles'],
    COR: ['Cornell Big Red', 'COR Big Red'],
    CP: ['Cal Poly Mustangs', 'CP Mustangs'],
    CREI: ['Creighton Bluejays', 'CREI Bluejays'],
    CSU: ['Colorado State Rams', 'CSU Rams'],
    CSUB: [
      'Cal State Bakersfield Roadrunners',
      'Bakersfield',
      'Bakersfield Roadrunners',
      'CSUB Roadrunners',
    ],
    CSUF: ['Cal State Fullerton Titans', 'Fullerton', 'Fullerton Titans', 'CSUF Titans'],
    CSUN: [
      'Cal State Northridge Matadors',
      'CSU Northridge',
      'CSU Northridge Matadors',
      'CSUN Matadors',
    ],
    DART: ['Dartmouth Big Green', 'DART Big Green'],
    DAV: ['Davidson Wildcats', 'DAV Wildcats'],
    DAY: ['Dayton Flyers', 'DAY Flyers'],
    DEL: ['Delaware Blue Hens', 'DEL Blue Hens'],
    DEN: ['Denver Pioneers', 'DEN Pioneers'],
    DEP: ['DePaul Blue Demons', 'DEP Blue Demons'],
    DETM: ['Detroit Mercy Titans', 'DETM Titans'],
    DREX: ['Drexel Dragons', 'DREX Dragons'],
    DRKE: ['Drake Bulldogs', 'DRKE Bulldogs'],
    DSU: ['Delaware State Hornets', 'DSU Hornets'],
    DUKE: ['Duke Blue Devils'],
    DUQ: ['Duquesne Dukes', 'DUQ Dukes'],
    ECU: ['East Carolina Pirates', 'ECU Pirates'],
    EIU: ['Eastern Illinois Panthers', 'E Illinois', 'E Illinois Panthers', 'EIU Panthers'],
    EKU: ['Eastern Kentucky Colonels', 'E Kentucky', 'E Kentucky Colonels', 'EKU Colonels'],
    ELON: ['Elon Phoenix'],
    EMU: ['Eastern Michigan Eagles', 'E Michigan', 'E Michigan Eagles', 'EMU Eagles'],
    ETAM: ['East Texas A&M Lions', 'ETAM Lions'],
    ETSU: ['East Tennessee State Buccaneers', 'ETSU Buccaneers'],
    EVAN: ['Evansville Purple Aces', 'EVAN Purple Aces'],
    EWU: ['Eastern Washington Eagles', 'E Washington', 'E Washington Eagles', 'EWU Eagles'],
    FAIR: ['Fairfield Stags', 'FAIR Stags'],
    FAMU: ['Florida A&M Rattlers', 'FAMU Rattlers'],
    FAU: ['Florida Atlantic Owls', 'FAU Owls'],
    FDU: ['Fairleigh Dickinson Knights', 'FDU Knights'],
    FGCU: ['Florida Gulf Coast Eagles', 'FGCU Eagles'],
    FIU: ['Florida International Panthers', 'FIU Panthers'],
    FLA: ['Florida Gators', 'FLA Gators'],
    FOR: ['Fordham Rams', 'FOR Rams'],
    FRES: ['Fresno State Bulldogs', 'FRES Bulldogs'],
    FSU: ['Florida State Seminoles', 'FSU Seminoles'],
    FUR: ['Furman Paladins', 'FUR Paladins'],
    GASO: ['Georgia Southern Eagles', 'GA Southern', 'GA Southern Eagles', 'GASO Eagles'],
    GAST: ['Georgia State Panthers', 'GAST Panthers'],
    GB: ['Green Bay Phoenix', 'GB Phoenix'],
    GCU: ['Grand Canyon Lopes', 'GCU Lopes'],
    GMU: ['George Mason Patriots', 'GMU Patriots'],
    GONZ: ['Gonzaga Bulldogs', 'GONZ Bulldogs'],
    GRAM: ['Grambling Tigers', 'GRAM Tigers'],
    GT: ['Georgia Tech Yellow Jackets', 'GT Yellow Jackets'],
    GTWN: ['Georgetown Hoyas', 'GTWN Hoyas'],
    GW: [
      'George Washington Revolutionaries',
      'G Washington',
      'G Washington Revolutionaries',
      'GW Revolutionaries',
    ],
    GWEB: ["Gardner-Webb Runnin' Bulldogs", "GWEB Runnin' Bulldogs"],
    HALL: ['Seton Hall Pirates', 'HALL Pirates'],
    HAMP: ['Hampton Pirates', 'HAMP Pirates'],
    HARV: ['Harvard Crimson', 'HARV Crimson'],
    HAW: ["Hawai'i Rainbow Warriors", 'HAW Rainbow Warriors'],
    HC: ['Holy Cross Crusaders', 'HC Crusaders'],
    HCU: ['Houston Christian Huskies', 'Hou Christian', 'Hou Christian Huskies', 'HCU Huskies'],
    HOF: ['Hofstra Pride', 'HOF Pride'],
    HOU: ['Houston Cougars', 'HOU Cougars'],
    HOW: ['Howard Bison', 'HOW Bison'],
    HPU: ['High Point Panthers', 'HPU Panthers'],
    IDHO: ['Idaho Vandals', 'IDHO Vandals'],
    IDST: ['Idaho State Bengals', 'IDST Bengals'],
    ILL: ['Illinois Fighting Illini', 'ILL Fighting Illini'],
    ILST: ['Illinois State Redbirds', 'ILST Redbirds'],
    INST: ['Indiana State Sycamores', 'INST Sycamores'],
    IONA: ['Iona Gaels'],
    IOWA: ['Iowa Hawkeyes'],
    ISU: ['Iowa State Cyclones', 'ISU Cyclones'],
    IU: ['Indiana Hoosiers', 'IU Hoosiers'],
    IUIN: ['IU Indianapolis Jaguars', 'IU Indy', 'IU Indy Jaguars', 'IUIN Jaguars'],
    JAX: ['Jacksonville Dolphins', 'JAX Dolphins'],
    JKST: ['Jackson State Tigers', 'JKST Tigers'],
    JMU: ['James Madison Dukes', 'JMU Dukes'],
    JOES: ["Saint Joseph's Hawks", 'JOES Hawks'],
    JXST: ['Jacksonville State Gamecocks', 'Jax State', 'Jax State Gamecocks', 'JXST Gamecocks'],
    KC: ['Kansas City Roos', 'KC Roos'],
    KENN: ['Kennesaw State Owls', 'KENN Owls'],
    KENT: ['Kent State Golden Flashes', 'KENT Golden Flashes'],
    KSU: ['Kansas State Wildcats', 'KSU Wildcats'],
    KU: ['Kansas Jayhawks', 'KU Jayhawks'],
    'L-MD': ['Loyola Maryland Greyhounds', 'Loyola MD', 'Loyola MD Greyhounds', 'L-MD Greyhounds'],
    LAF: ['Lafayette Leopards', 'LAF Leopards'],
    LAM: ['Lamar Cardinals', 'LAM Cardinals'],
    LAS: ['La Salle Explorers', 'LAS Explorers'],
    LBSU: ['Long Beach State Beach', 'LBSU Beach'],
    LEH: ['Lehigh Mountain Hawks', 'LEH Mountain Hawks'],
    LEM: ['Le Moyne Dolphins', 'LEM Dolphins'],
    LIB: ['Liberty Flames', 'LIB Flames'],
    LIP: ['Lipscomb Bisons', 'LIP Bisons'],
    LIU: ['Long Island University Sharks', 'Long Island', 'Long Island Sharks', 'LIU Sharks'],
    LMU: ['Loyola Marymount Lions', 'LMU Lions'],
    LONG: ['Longwood Lancers', 'LONG Lancers'],
    LOU: ['Louisville Cardinals', 'LOU Cardinals'],
    LR: ['Little Rock Trojans', 'LR Trojans'],
    LSU: ['LSU Tigers'],
    LT: ['Louisiana Tech Bulldogs', 'LT Bulldogs'],
    LUC: ['Loyola Chicago Ramblers', 'LUC Ramblers'],
    'M-OH': ['Miami (OH) RedHawks', 'M-OH RedHawks'],
    MAN: ['Manhattan Jaspers', 'MAN Jaspers'],
    MARQ: ['Marquette Golden Eagles', 'MARQ Golden Eagles'],
    MASS: ['Massachusetts Minutemen', 'UMass', 'UMass Minutemen', 'MASS Minutemen'],
    MCN: ['McNeese Cowboys', 'MCN Cowboys'],
    MD: ['Maryland Terrapins', 'MD Terrapins'],
    ME: ['Maine Black Bears', 'ME Black Bears'],
    MEM: ['Memphis Tigers', 'MEM Tigers'],
    MER: ['Mercer Bears', 'MER Bears'],
    MERC: ['Mercyhurst Lakers', 'MERC Lakers'],
    MIA: ['Miami Hurricanes', 'MIA Hurricanes'],
    MICH: ['Michigan Wolverines', 'MICH Wolverines'],
    MILW: ['Milwaukee Panthers', 'MILW Panthers'],
    MINN: ['Minnesota Golden Gophers', 'MINN Golden Gophers'],
    MISS: ['Ole Miss Rebels', 'MISS Rebels'],
    MIZ: ['Missouri Tigers', 'MIZ Tigers'],
    MONM: ['Monmouth Hawks', 'MONM Hawks'],
    MONT: ['Montana Grizzlies', 'MONT Grizzlies'],
    MORE: ['Morehead State Eagles', 'MORE Eagles'],
    MORG: ['Morgan State Bears', 'MORG Bears'],
    MOST: ['Missouri State Bears', 'MOST Bears'],
    MRMK: ['Merrimack Warriors', 'MRMK Warriors'],
    MRSH: ['Marshall Thundering Herd', 'MRSH Thundering Herd'],
    MRST: ['Marist Red Foxes', 'MRST Red Foxes'],
    MSM: ["Mount St. Mary's Mountaineers", 'MSM Mountaineers'],
    MSST: ['Mississippi State Bulldogs', 'MSST Bulldogs'],
    MSU: ['Michigan State Spartans', 'MSU Spartans'],
    MTST: ['Montana State Bobcats', 'MTST Bobcats'],
    MTSU: ['Middle Tennessee Blue Raiders', 'MTSU Blue Raiders'],
    MUR: ['Murray State Racers', 'MUR Racers'],
    MVSU: [
      'Mississippi Valley State Delta Devils',
      'Miss Valley St',
      'Miss Valley St Delta Devils',
      'MVSU Delta Devils',
    ],
    NAU: ['Northern Arizona Lumberjacks', 'N Arizona', 'N Arizona Lumberjacks', 'NAU Lumberjacks'],
    NAVY: ['Navy Midshipmen'],
    NCAT: ['North Carolina A&T Aggies', 'NC A&T', 'NC A&T Aggies', 'NCAT Aggies'],
    NCCU: ['North Carolina Central Eagles', 'NC Central', 'NC Central Eagles', 'NCCU Eagles'],
    NCSU: ['NC State Wolfpack', 'NCSU Wolfpack'],
    ND: ['Notre Dame Fighting Irish', 'ND Fighting Irish'],
    NDSU: ['North Dakota State Bison', 'N Dakota St', 'N Dakota St Bison', 'NDSU Bison'],
    NE: ['Northeastern Huskies', 'NE Huskies'],
    NEB: ['Nebraska Cornhuskers', 'NEB Cornhuskers'],
    NEV: ['Nevada Wolf Pack', 'NEV Wolf Pack'],
    NHVN: ['New Haven Chargers', 'NHVN Chargers'],
    NIA: ['Niagara Purple Eagles', 'NIA Purple Eagles'],
    NICH: ['Nicholls Colonels', 'NICH Colonels'],
    NIU: ['Northern Illinois Huskies', 'N Illinois', 'N Illinois Huskies', 'NIU Huskies'],
    NJIT: ['NJIT Highlanders'],
    NKU: ['Northern Kentucky Norse', 'N Kentucky', 'N Kentucky Norse', 'NKU Norse'],
    NMSU: ['New Mexico State Aggies', 'NMSU Aggies'],
    NORF: ['Norfolk State Spartans', 'NORF Spartans'],
    NU: ['Northwestern Wildcats', 'NU Wildcats'],
    NWST: ['Northwestern State Demons', "N'Western St", "N'Western St Demons", 'NWST Demons'],
    OAK: ['Oakland Golden Grizzlies', 'OAK Golden Grizzlies'],
    ODU: ['Old Dominion Monarchs', 'ODU Monarchs'],
    OHIO: ['Ohio Bobcats'],
    OKST: ['Oklahoma State Cowboys', 'OKST Cowboys'],
    OMA: ['Omaha Mavericks', 'OMA Mavericks'],
    ORE: ['Oregon Ducks', 'ORE Ducks'],
    ORST: ['Oregon State Beavers', 'ORST Beavers'],
    ORU: ['Oral Roberts Golden Eagles', 'ORU Golden Eagles'],
    OSU: ['Ohio State Buckeyes', 'OSU Buckeyes'],
    OU: ['Oklahoma Sooners', 'OU Sooners'],
    PAC: ['Pacific Tigers', 'PAC Tigers'],
    PENN: ['Pennsylvania Quakers', 'Penn Quakers'],
    PEPP: ['Pepperdine Waves', 'PEPP Waves'],
    PFW: ['Purdue Fort Wayne Mastodons', 'Purdue FW', 'Purdue FW Mastodons', 'PFW Mastodons'],
    PITT: ['Pittsburgh Panthers', 'Pitt Panthers'],
    PORT: ['Portland Pilots', 'PORT Pilots'],
    PRES: ['Presbyterian Blue Hose', 'PRES Blue Hose'],
    PRIN: ['Princeton Tigers', 'PRIN Tigers'],
    PROV: ['Providence Friars', 'PROV Friars'],
    PRST: ['Portland State Vikings', 'PRST Vikings'],
    PSU: ['Penn State Nittany Lions', 'PSU Nittany Lions'],
    PUR: ['Purdue Boilermakers', 'PUR Boilermakers'],
    PV: ['Prairie View A&M Panthers', 'Prairie View', 'Prairie View Panthers', 'PV Panthers'],
    QUIN: ['Quinnipiac Bobcats', 'QUIN Bobcats'],
    RAD: ['Radford Highlanders', 'RAD Highlanders'],
    RGV: [
      'UT Rio Grande Valley Vaqueros',
      'UT Rio Grande',
      'UT Rio Grande Vaqueros',
      'RGV Vaqueros',
    ],
    RICE: ['Rice Owls'],
    RICH: ['Richmond Spiders', 'RICH Spiders'],
    RID: ['Rider Broncs', 'RID Broncs'],
    RMU: ['Robert Morris Colonials', 'RMU Colonials'],
    RUTG: ['Rutgers Scarlet Knights', 'RUTG Scarlet Knights'],
    SAC: ['Sacramento State Hornets', 'SAC Hornets'],
    SAM: ['Samford Bulldogs', 'SAM Bulldogs'],
    SBU: ['St. Bonaventure Bonnies', 'SBU Bonnies'],
    SC: ['South Carolina Gamecocks', 'SC Gamecocks'],
    SCST: ['South Carolina State Bulldogs', 'SC State Bulldogs'],
    SCU: ['Santa Clara Broncos', 'SCU Broncos'],
    SDAK: ['South Dakota Coyotes', 'SDAK Coyotes'],
    SDST: [
      'South Dakota State Jackrabbits',
      'S Dakota St',
      'S Dakota St Jackrabbits',
      'SDST Jackrabbits',
    ],
    SDSU: ['San Diego State Aztecs', 'SDSU Aztecs'],
    SEA: ['Seattle U Redhawks', 'SEA Redhawks'],
    SELA: ['SE Louisiana Lions', 'SELA Lions'],
    SEMO: [
      'Southeast Missouri State Redhawks',
      'SE Missouri',
      'SE Missouri Redhawks',
      'SEMO Redhawks',
    ],
    SF: ['San Francisco Dons', 'SF Dons'],
    SFA: ['Stephen F. Austin Lumberjacks', 'SF Austin', 'SF Austin Lumberjacks', 'SFA Lumberjacks'],
    SHSU: ['Sam Houston Bearkats', 'SHSU Bearkats'],
    SHU: ['Sacred Heart Pioneers', 'SHU Pioneers'],
    SIE: ['Siena Saints', 'SIE Saints'],
    SIU: ['Southern Illinois Salukis', 'S Illinois', 'S Illinois Salukis', 'SIU Salukis'],
    SIUE: ['SIU Edwardsville Cougars', 'SIUE Cougars'],
    SJSU: ['San José State Spartans', 'SJSU Spartans'],
    SJU: ["St. John's Red Storm", 'SJU Red Storm'],
    SLU: ['Saint Louis Billikens', 'SLU Billikens'],
    SMC: ["Saint Mary's Gaels", 'SMC Gaels'],
    SMU: ['SMU Mustangs'],
    SOU: ['Southern Jaguars', 'SOU Jaguars'],
    SPU: ["Saint Peter's Peacocks", 'SPU Peacocks'],
    STAN: ['Stanford Cardinal', 'STAN Cardinal'],
    STBK: ['Stony Brook Seawolves', 'STBK Seawolves'],
    STET: ['Stetson Hatters', 'STET Hatters'],
    STMN: ['St. Thomas Tommies', 'St Thomas', 'STMN Tommies'],
    STO: ['Stonehill Skyhawks', 'STO Skyhawks'],
    SUU: ['Southern Utah Thunderbirds', 'SUU Thunderbirds'],
    SYR: ['Syracuse Orange', 'SYR Orange'],
    'TA&M': ['Texas A&M Aggies', 'TA&M Aggies'],
    TAR: ['Tarleton State Texans', 'TAR Texans'],
    TCU: ['TCU Horned Frogs'],
    TEM: ['Temple Owls', 'TEM Owls'],
    TENN: ['Tennessee Volunteers', 'TENN Volunteers'],
    TEX: ['Texas Longhorns', 'TEX Longhorns'],
    TLSA: ['Tulsa Golden Hurricane', 'TLSA Golden Hurricane'],
    TNST: ['Tennessee State Tigers', 'TNST Tigers'],
    TNTC: ['Tennessee Tech Golden Eagles', 'TNTC Golden Eagles'],
    TOL: ['Toledo Rockets', 'TOL Rockets'],
    TOW: ['Towson Tigers', 'TOW Tigers'],
    TROY: ['Troy Trojans'],
    TTU: ['Texas Tech Red Raiders', 'TTU Red Raiders'],
    TULN: ['Tulane Green Wave', 'TULN Green Wave'],
    TXSO: ['Texas Southern Tigers', 'TXSO Tigers'],
    TXST: ['Texas State Bobcats', 'TXST Bobcats'],
    UAB: ['UAB Blazers'],
    UALB: ['UAlbany Great Danes', 'UALB Great Danes'],
    UAPB: [
      'Arkansas-Pine Bluff Golden Lions',
      'AR-Pine Bluff',
      'AR-Pine Bluff Golden Lions',
      'UAPB Golden Lions',
    ],
    UCD: ['UC Davis Aggies', 'UCD Aggies'],
    UCF: ['UCF Knights'],
    UCI: ['UC Irvine Anteaters', 'UCI Anteaters'],
    UCLA: ['UCLA Bruins'],
    UCR: ['UC Riverside Highlanders', 'UCR Highlanders'],
    UCSB: ['UC Santa Barbara Gauchos', 'Santa Barbara', 'Santa Barbara Gauchos', 'UCSB Gauchos'],
    UCSD: ['UC San Diego Tritons', 'UCSD Tritons'],
    UGA: ['Georgia Bulldogs', 'UGA Bulldogs'],
    UIC: ['UIC Flames'],
    UIW: ['Incarnate Word Cardinals', 'UIW Cardinals'],
    UK: ['Kentucky Wildcats', 'UK Wildcats'],
    UL: ["Louisiana Ragin' Cajuns", "UL Ragin' Cajuns"],
    ULM: ['UL Monroe Warhawks', 'ULM Warhawks'],
    UMBC: ['UMBC Retrievers'],
    UMES: ['Maryland Eastern Shore Hawks', 'MD Eastern', 'MD Eastern Hawks', 'UMES Hawks'],
    UML: ['UMass Lowell River Hawks', 'UML River Hawks'],
    UNA: ['North Alabama Lions', 'UNA Lions'],
    UNC: ['North Carolina Tar Heels', 'UNC Tar Heels'],
    UNCA: ['UNC Asheville Bulldogs', 'UNCA Bulldogs'],
    UNCG: ['UNC Greensboro Spartans', 'UNCG Spartans'],
    UNCO: ['Northern Colorado Bears', 'N Colorado', 'N Colorado Bears', 'UNCO Bears'],
    UNCW: ['UNC Wilmington Seahawks', 'UNCW Seahawks'],
    UND: ['North Dakota Fighting Hawks', 'UND Fighting Hawks'],
    UNF: ['North Florida Ospreys', 'UNF Ospreys'],
    UNH: ['New Hampshire Wildcats', 'UNH Wildcats'],
    UNI: ['Northern Iowa Panthers', 'UNI Panthers'],
    UNLV: ['UNLV Rebels'],
    UNM: ['New Mexico Lobos', 'UNM Lobos'],
    UNO: [
      'LSU New Orleans Privateers',
      'NOLA',
      'LSU N Orleans',
      'LSU New Orleans',
      'LSU N Orleans Privateers',
      'NOLA Privateers',
    ],
    UNT: ['North Texas Mean Green', 'UNT Mean Green'],
    UPST: ['South Carolina Upstate Spartans', 'SC Upstate', 'SC Upstate Spartans', 'UPST Spartans'],
    URI: ['Rhode Island Rams', 'URI Rams'],
    USA: ['South Alabama Jaguars', 'USA Jaguars'],
    USC: ['USC Trojans'],
    USD: ['San Diego Toreros', 'USD Toreros'],
    USF: ['South Florida Bulls', 'USF Bulls'],
    USM: ['Southern Miss Golden Eagles', 'USM Golden Eagles'],
    USU: ['Utah State Aggies', 'USU Aggies'],
    UTA: ['UT Arlington Mavericks', 'UTA Mavericks'],
    UTAH: ['Utah Utes'],
    UTC: ['Chattanooga Mocs', 'UTC Mocs'],
    UTEP: ['UTEP Miners'],
    UTM: ['UT Martin Skyhawks', 'UTM Skyhawks'],
    UTSA: ['UTSA Roadrunners'],
    UTU: ['Utah Tech Trailblazers', 'UTU Trailblazers'],
    UVA: ['Virginia Cavaliers', 'UVA Cavaliers'],
    UVM: ['Vermont Catamounts', 'UVM Catamounts'],
    UVU: ['Utah Valley Wolverines', 'UVU Wolverines'],
    VAL: ['Valparaiso Beacons', 'VAL Beacons'],
    VAN: ['Vanderbilt Commodores', 'VAN Commodores'],
    VCU: ['VCU Rams'],
    VILL: ['Villanova Wildcats', 'VILL Wildcats'],
    VMI: ['VMI Keydets'],
    VT: ['Virginia Tech Hokies', 'VT Hokies'],
    'W&M': ['William & Mary Tribe', 'W&M Tribe'],
    WAG: ['Wagner Seahawks', 'WAG Seahawks'],
    WAKE: ['Wake Forest Demon Deacons', 'WAKE Demon Deacons'],
    WASH: ['Washington Huskies', 'WASH Huskies'],
    WCU: ['Western Carolina Catamounts', 'W Carolina', 'W Carolina Catamounts', 'WCU Catamounts'],
    WEB: ['Weber State Wildcats', 'WEB Wildcats'],
    WGA: ['West Georgia Wolves', 'WGA Wolves'],
    WICH: ['Wichita State Shockers', 'WICH Shockers'],
    WIN: ['Winthrop Eagles', 'WIN Eagles'],
    WIS: ['Wisconsin Badgers', 'WIS Badgers'],
    WIU: [
      'Western Illinois Leathernecks',
      'W Illinois',
      'W Illinois Leathernecks',
      'WIU Leathernecks',
    ],
    WKU: [
      'Western Kentucky Hilltoppers',
      'Western KY',
      'Western KY Hilltoppers',
      'WKU Hilltoppers',
    ],
    WMU: ['Western Michigan Broncos', 'W Michigan', 'W Michigan Broncos', 'WMU Broncos'],
    WOF: ['Wofford Terriers', 'WOF Terriers'],
    WRST: ['Wright State Raiders', 'WRST Raiders'],
    WSU: ['Washington State Cougars', 'WSU Cougars'],
    WVU: ['West Virginia Mountaineers', 'WVU Mountaineers'],
    WYO: ['Wyoming Cowboys', 'WYO Cowboys'],
    XAV: ['Xavier Musketeers', 'XAV Musketeers'],
    YALE: ['Yale Bulldogs'],
    YSU: ['Youngstown State Penguins', 'YSU Penguins'],
  },
  basketball_wncaab: {
    AAMU: ['Alabama A&M Bulldogs', 'AAMU Bulldogs'],
    ACU: [
      'Abilene Christian Wildcats',
      'Abilene Chrstn',
      'Abilene Chrstn Wildcats',
      'ACU Wildcats',
    ],
    AF: ['Air Force Falcons', 'AF Falcons'],
    AKR: ['Akron Zips', 'AKR Zips'],
    ALA: ['Alabama Crimson Tide', 'ALA Crimson Tide'],
    ALCN: ['Alcorn State Lady Braves', 'ALCN Lady Braves'],
    ALST: ['Alabama State Lady Hornets', 'ALST Lady Hornets'],
    AMCC: [
      'Texas A&M-Corpus Christi Islanders',
      'Texas A&M-CC',
      'Texas A&M-CC Islanders',
      'AMCC Islanders',
    ],
    AMER: ['American University Eagles', 'American', 'American Eagles', 'AMER Eagles'],
    APP: ['App State Mountaineers', 'APP Mountaineers'],
    APSU: ['Austin Peay Governors', 'APSU Governors'],
    ARIZ: ['Arizona Wildcats', 'ARIZ Wildcats'],
    ARK: ['Arkansas Razorbacks', 'ARK Razorbacks'],
    ARMY: ['Army Black Knights'],
    ARST: ['Arkansas State Red Wolves', 'ARST Red Wolves'],
    ASU: ['Arizona State Sun Devils', 'ASU Sun Devils'],
    AUB: ['Auburn Tigers', 'AUB Tigers'],
    BALL: ['Ball State Cardinals', 'BALL Cardinals'],
    BAY: ['Baylor Bears', 'BAY Bears'],
    BC: ['Boston College Eagles', 'BC Eagles'],
    BCU: ['Bethune-Cookman Wildcats', 'Bethune', 'Bethune Wildcats', 'BCU Wildcats'],
    BEL: ['Belmont Bruins', 'BEL Bruins'],
    BELL: ['Bellarmine Knights', 'BELL Knights'],
    BGSU: ['Bowling Green Falcons', 'BGSU Falcons'],
    BING: ['Binghamton Bearcats', 'BING Bearcats'],
    BOIS: ['Boise State Broncos', 'BOIS Broncos'],
    BRAD: ['Bradley Braves', 'BRAD Braves'],
    BRWN: ['Brown Bears', 'BRWN Bears'],
    BRY: ['Bryant Bulldogs', 'BRY Bulldogs'],
    BU: ['Boston University Terriers', 'Boston U', 'Boston U Terriers', 'BU Terriers'],
    BUCK: ['Bucknell Bison', 'BUCK Bison'],
    BUF: ['Buffalo Bulls', 'BUF Bulls'],
    BUT: ['Butler Bulldogs', 'BTLR', 'BTLR Bulldogs'],
    BYU: ['BYU Cougars'],
    CAL: ['California Golden Bears', 'CAL Golden Bears'],
    CAM: ['Campbell Fighting Camels', 'CAM Fighting Camels'],
    CAN: ['Canisius Golden Griffins', 'CAN Golden Griffins'],
    CARK: ['Central Arkansas Bears', 'C Arkansas', 'C Arkansas Bears', 'CARK Bears'],
    CBU: ['California Baptist Lancers', 'CA Baptist', 'CA Baptist Lancers', 'CBU Lancers'],
    CCSU: [
      'Central Connecticut Blue Devils',
      'C Connecticut',
      'C Connecticut Blue Devils',
      'CCSU Blue Devils',
    ],
    CCU: ['Coastal Carolina Chanticleers', 'Coastal', 'Coastal Chanticleers', 'CCU Chanticleers'],
    CHSO: [
      'Charleston Southern Buccaneers',
      'Charleston So',
      'Charleston So Buccaneers',
      'CHSO Buccaneers',
    ],
    CHST: ['Chicago State Cougars', 'CHST Cougars'],
    CIN: ['Cincinnati Bearcats', 'CIN Bearcats'],
    CLE: ['Cleveland State Vikings', 'CLE Vikings'],
    CLEM: ['Clemson Tigers', 'CLEM Tigers'],
    CLT: ['Charlotte 49ers', 'CLT 49ers'],
    CMU: ['Central Michigan Chippewas', 'C Michigan', 'C Michigan Chippewas', 'CMU Chippewas'],
    COFC: ['Charleston Cougars', 'COFC Cougars'],
    COLG: ['Colgate Raiders', 'COLG Raiders'],
    COLO: ['Colorado Buffaloes', 'COLO Buffaloes'],
    COLU: ['Columbia Lions', 'COLU Lions'],
    CONN: ['UConn Huskies', 'CONN Huskies'],
    COPP: ['Coppin State Eagles', 'COPP Eagles'],
    COR: ['Cornell Big Red', 'COR Big Red'],
    CP: ['Cal Poly Mustangs', 'CP Mustangs'],
    CREI: ['Creighton Bluejays', 'CREI Bluejays'],
    CSU: ['Colorado State Rams', 'CSU Rams'],
    CSUB: [
      'Cal State Bakersfield Roadrunners',
      'Bakersfield',
      'Bakersfield Roadrunners',
      'CSUB Roadrunners',
    ],
    CSUF: ['Cal State Fullerton Titans', 'Fullerton', 'Fullerton Titans', 'CSUF Titans'],
    CSUN: [
      'Cal State Northridge Matadors',
      'CSU Northridge',
      'CSU Northridge Matadors',
      'CSUN Matadors',
    ],
    DART: ['Dartmouth Big Green', 'DART Big Green'],
    DAV: ['Davidson Wildcats', 'DAV Wildcats'],
    DAY: ['Dayton Flyers', 'DAY Flyers'],
    DEL: ['Delaware Blue Hens', 'DEL Blue Hens'],
    DEN: ['Denver Pioneers', 'DEN Pioneers'],
    DEP: ['DePaul Blue Demons', 'DEP Blue Demons'],
    DETM: ['Detroit Mercy Titans', 'DETM Titans'],
    DREX: ['Drexel Dragons', 'DREX Dragons'],
    DRKE: ['Drake Bulldogs', 'DRKE Bulldogs'],
    DSU: ['Delaware State Hornets', 'DSU Hornets'],
    DUKE: ['Duke Blue Devils'],
    DUQ: ['Duquesne Dukes', 'DUQ Dukes'],
    ECU: ['East Carolina Pirates', 'ECU Pirates'],
    EIU: ['Eastern Illinois Panthers', 'E Illinois', 'E Illinois Panthers', 'EIU Panthers'],
    EKU: ['Eastern Kentucky Colonels', 'E Kentucky', 'E Kentucky Colonels', 'EKU Colonels'],
    ELON: ['Elon Phoenix'],
    EMU: ['Eastern Michigan Eagles', 'E Michigan', 'E Michigan Eagles', 'EMU Eagles'],
    ETAM: ['East Texas A&M Lions', 'ETAM Lions'],
    ETSU: ['East Tennessee State Bucs', 'ETSU Bucs'],
    EVAN: ['Evansville Purple Aces', 'EVAN Purple Aces'],
    EWU: ['Eastern Washington Eagles', 'E Washington', 'E Washington Eagles', 'EWU Eagles'],
    FAIR: ['Fairfield Stags', 'FAIR Stags'],
    FAMU: ['Florida A&M Rattlers', 'FAMU Rattlers'],
    FAU: ['Florida Atlantic Owls', 'FAU Owls'],
    FDU: ['Fairleigh Dickinson Knights', 'FDU Knights'],
    FGCU: ['Florida Gulf Coast Eagles', 'FGCU Eagles'],
    FIU: ['Florida International Panthers', 'FIU Panthers'],
    FLA: ['Florida Gators', 'FLA Gators'],
    FOR: ['Fordham Rams', 'FOR Rams'],
    FRES: ['Fresno State Bulldogs', 'FRES Bulldogs'],
    FSU: ['Florida State Seminoles', 'FSU Seminoles'],
    FUR: ['Furman Paladins', 'FUR Paladins'],
    GASO: ['Georgia Southern Eagles', 'GA Southern', 'GA Southern Eagles', 'GASO Eagles'],
    GAST: ['Georgia State Panthers', 'GAST Panthers'],
    GB: ['Green Bay Phoenix', 'GB Phoenix'],
    GCU: ['Grand Canyon Lopes', 'GCU Lopes'],
    GMU: ['George Mason Patriots', 'GMU Patriots'],
    GONZ: ['Gonzaga Bulldogs', 'GONZ Bulldogs'],
    GRAM: ['Grambling Lady Tigers', 'GRAM Lady Tigers'],
    GT: ['Georgia Tech Yellow Jackets', 'GT Yellow Jackets'],
    GTWN: ['Georgetown Hoyas', 'GTWN Hoyas'],
    GW: [
      'George Washington Revolutionaries',
      'G Washington',
      'G Washington Revolutionaries',
      'GW Revolutionaries',
    ],
    GWEB: ["Gardner-Webb Runnin' Bulldogs", "GWEB Runnin' Bulldogs"],
    HALL: ['Seton Hall Pirates', 'HALL Pirates'],
    HAMP: ['Hampton Lady Pirates', 'HAMP Lady Pirates'],
    HARV: ['Harvard Crimson', 'HARV Crimson'],
    HAW: ["Hawai'i Rainbow Warriors", 'HAW Rainbow Warriors'],
    HC: ['Holy Cross Crusaders', 'HC Crusaders'],
    HCU: ['Houston Christian Huskies', 'Hou Christian', 'Hou Christian Huskies', 'HCU Huskies'],
    HOF: ['Hofstra Pride', 'HOF Pride'],
    HOU: ['Houston Cougars', 'HOU Cougars'],
    HOW: ['Howard Bison', 'HOW Bison'],
    HPU: ['High Point Panthers', 'HPU Panthers'],
    IDHO: ['Idaho Vandals', 'IDHO Vandals'],
    IDST: ['Idaho State Bengals', 'IDST Bengals'],
    ILL: ['Illinois Fighting Illini', 'ILL Fighting Illini'],
    ILST: ['Illinois State Redbirds', 'ILST Redbirds'],
    INST: ['Indiana State Sycamores', 'INST Sycamores'],
    IONA: ['Iona Gaels'],
    IOWA: ['Iowa Hawkeyes'],
    ISU: ['Iowa State Cyclones', 'ISU Cyclones'],
    IU: ['Indiana Hoosiers', 'IU Hoosiers'],
    IUIN: ['IU Indianapolis Jaguars', 'IU Indy', 'IU Indy Jaguars', 'IUIN Jaguars'],
    JAX: ['Jacksonville Dolphins', 'JAX Dolphins'],
    JKST: ['Jackson State Lady Tigers', 'JKST Lady Tigers'],
    JMU: ['James Madison Dukes', 'JMU Dukes'],
    JOES: ["Saint Joseph's Hawks", 'JOES Hawks'],
    JXST: ['Jacksonville State Gamecocks', 'Jax State', 'Jax State Gamecocks', 'JXST Gamecocks'],
    KC: ['Kansas City Roos', 'KC Roos'],
    KENN: ['Kennesaw State Owls', 'KENN Owls'],
    KENT: ['Kent State Golden Flashes', 'KENT Golden Flashes'],
    KSU: ['Kansas State Wildcats', 'KSU Wildcats'],
    KU: ['Kansas Jayhawks', 'KU Jayhawks'],
    'L-MD': ['Loyola Maryland Greyhounds', 'Loyola MD', 'Loyola MD Greyhounds', 'L-MD Greyhounds'],
    LAF: ['Lafayette Leopards', 'LAF Leopards'],
    LAM: ['Lamar Cardinals', 'LAM Cardinals'],
    LAS: ['La Salle Explorers', 'LAS Explorers'],
    LBSU: ['Long Beach State Beach', 'LBSU Beach'],
    LEH: ['Lehigh Mountain Hawks', 'LEH Mountain Hawks'],
    LEM: ['Le Moyne Dolphins', 'LEM Dolphins'],
    LIB: ['Liberty Flames', 'LIB Flames'],
    LIN: ['Lindenwood Lions', 'LIN Lions'],
    LIP: ['Lipscomb Bisons', 'LIP Bisons'],
    LIU: ['Long Island University Sharks', 'Long Island', 'Long Island Sharks', 'LIU Sharks'],
    LMU: ['Loyola Marymount Lions', 'LMU Lions'],
    LONG: ['Longwood Lancers', 'LONG Lancers'],
    LOU: ['Louisville Cardinals', 'LOU Cardinals'],
    LR: ['Little Rock Trojans', 'LR Trojans'],
    LSU: ['LSU Tigers'],
    LT: ['Louisiana Tech Lady Techsters', 'LT Lady Techsters'],
    LUC: ['Loyola Chicago Ramblers', 'LUC Ramblers'],
    'M-OH': ['Miami (OH) RedHawks', 'M-OH RedHawks'],
    MAN: ['Manhattan Jaspers', 'MAN Jaspers'],
    MARQ: ['Marquette Golden Eagles', 'MARQ Golden Eagles'],
    MASS: ['Massachusetts Minutewomen', 'UMass', 'UMass Minutewomen', 'MASS Minutewomen'],
    MCN: ['McNeese Cowgirls', 'MCN Cowgirls'],
    MD: ['Maryland Terrapins', 'MD Terrapins'],
    ME: ['Maine Black Bears', 'ME Black Bears'],
    MEM: ['Memphis Tigers', 'MEM Tigers'],
    MER: ['Mercer Bears', 'MER Bears'],
    MIA: ['Miami Hurricanes', 'MIA Hurricanes'],
    MICH: ['Michigan Wolverines', 'MICH Wolverines'],
    MILW: ['Milwaukee Panthers', 'MILW Panthers'],
    MINN: ['Minnesota Golden Gophers', 'MINN Golden Gophers'],
    MISS: ['Ole Miss Rebels', 'MISS Rebels'],
    MIZ: ['Missouri Tigers', 'MIZ Tigers'],
    MONM: ['Monmouth Hawks', 'MONM Hawks'],
    MONT: ['Montana Lady Griz', 'MONT Lady Griz'],
    MORE: ['Morehead State Eagles', 'MORE Eagles'],
    MORG: ['Morgan State Lady Bears', 'MORG Lady Bears'],
    MOST: ['Missouri State Lady Bears', 'MOST Lady Bears'],
    MRMK: ['Merrimack Warriors', 'MRMK Warriors'],
    MRSH: ['Marshall Thundering Herd', 'MRSH Thundering Herd'],
    MRST: ['Marist Red Foxes', 'MRST Red Foxes'],
    MSM: ["Mount St. Mary's Mountaineers", 'MSM Mountaineers'],
    MSST: ['Mississippi State Bulldogs', 'MSST Bulldogs'],
    MSU: ['Michigan State Spartans', 'MSU Spartans'],
    MTST: ['Montana State Bobcats', 'MTST Bobcats'],
    MTSU: ['Middle Tennessee Blue Raiders', 'MTSU Blue Raiders'],
    MUR: ['Murray State Racers', 'MUR Racers'],
    MVSU: [
      'Mississippi Valley State Devilettes',
      'Miss Valley St',
      'Miss Valley St Devilettes',
      'MVSU Devilettes',
    ],
    NAU: ['Northern Arizona Lumberjacks', 'N Arizona', 'N Arizona Lumberjacks', 'NAU Lumberjacks'],
    NAVY: ['Navy Midshipmen'],
    NCAT: ['North Carolina A&T Aggies', 'NC A&T', 'NC A&T Aggies', 'NCAT Aggies'],
    NCCU: ['North Carolina Central Eagles', 'NC Central', 'NC Central Eagles', 'NCCU Eagles'],
    NCSU: ['NC State Wolfpack', 'NCSU Wolfpack'],
    ND: ['Notre Dame Fighting Irish', 'ND Fighting Irish'],
    NDSU: ['North Dakota State Bison', 'N Dakota St', 'N Dakota St Bison', 'NDSU Bison'],
    NE: ['Northeastern Huskies', 'NE Huskies'],
    NEB: ['Nebraska Cornhuskers', 'NEB Cornhuskers'],
    NEV: ['Nevada Wolf Pack', 'NEV Wolf Pack'],
    NHVN: ['New Haven Chargers', 'NHVN Chargers'],
    NIA: ['Niagara Purple Eagles', 'NIA Purple Eagles'],
    NICH: ['Nicholls Colonels', 'NICH Colonels'],
    NIU: ['Northern Illinois Huskies', 'N Illinois', 'N Illinois Huskies', 'NIU Huskies'],
    NJIT: ['NJIT Highlanders'],
    NKU: ['Northern Kentucky Norse', 'N Kentucky', 'N Kentucky Norse', 'NKU Norse'],
    NMSU: ['New Mexico State Aggies', 'NMSU Aggies'],
    NORF: ['Norfolk State Spartans', 'NORF Spartans'],
    NU: ['Northwestern Wildcats', 'NU Wildcats'],
    NWST: [
      'Northwestern State Lady Demons',
      "N'Western St",
      "N'Western St Lady Demons",
      'NWST Lady Demons',
    ],
    OAK: ['Oakland Golden Grizzlies', 'OAK Golden Grizzlies'],
    ODU: ['Old Dominion Monarchs', 'ODU Monarchs'],
    OHIO: ['Ohio Bobcats'],
    OKST: ['Oklahoma State Cowgirls', 'OKST Cowgirls'],
    OMA: ['Omaha Mavericks', 'OMA Mavericks'],
    ORE: ['Oregon Ducks', 'ORE Ducks'],
    ORST: ['Oregon State Beavers', 'ORST Beavers'],
    ORU: ['Oral Roberts Golden Eagles', 'ORU Golden Eagles'],
    OSU: ['Ohio State Buckeyes', 'OSU Buckeyes'],
    OU: ['Oklahoma Sooners', 'OU Sooners'],
    PAC: ['Pacific Tigers', 'PAC Tigers'],
    PENN: ['Pennsylvania Quakers', 'Penn Quakers'],
    PEPP: ['Pepperdine Waves', 'PEPP Waves'],
    PFW: ['Purdue Fort Wayne Mastodons', 'Purdue FW', 'Purdue FW Mastodons', 'PFW Mastodons'],
    PITT: ['Pittsburgh Panthers', 'Pitt Panthers'],
    PORT: ['Portland Pilots', 'PORT Pilots'],
    PRES: ['Presbyterian Blue Hose', 'PRES Blue Hose'],
    PRIN: ['Princeton Tigers', 'PRIN Tigers'],
    PROV: ['Providence Friars', 'PROV Friars'],
    PRST: ['Portland State Vikings', 'PRST Vikings'],
    PSU: ['Penn State Lady Lions', 'PSU Lady Lions'],
    PUR: ['Purdue Boilermakers', 'PUR Boilermakers'],
    PV: [
      'Prairie View A&M Lady Panthers',
      'Prairie View',
      'Prairie View Lady Panthers',
      'PV Lady Panthers',
    ],
    QUC: ['Queens University Royals', 'Queens University', 'Queens Royals', 'QUC Royals'],
    QUIN: ['Quinnipiac Bobcats', 'QUIN Bobcats'],
    RAD: ['Radford Highlanders', 'RAD Highlanders'],
    RGV: [
      'UT Rio Grande Valley Vaqueros',
      'UT Rio Grande',
      'UT Rio Grande Vaqueros',
      'RGV Vaqueros',
    ],
    RICE: ['Rice Owls'],
    RICH: ['Richmond Spiders', 'RICH Spiders'],
    RID: ['Rider Broncs', 'RID Broncs'],
    RMU: ['Robert Morris Colonials', 'RMU Colonials'],
    RUTG: ['Rutgers Scarlet Knights', 'RUTG Scarlet Knights'],
    SAC: ['Sacramento State Hornets', 'SAC Hornets'],
    SAM: ['Samford Bulldogs', 'SAM Bulldogs'],
    SBU: ['St. Bonaventure Bonnies', 'SBU Bonnies'],
    SC: ['South Carolina Gamecocks', 'SC Gamecocks'],
    SCST: ['South Carolina State Lady Bulldogs', 'SC State Lady Bulldogs'],
    SCU: ['Santa Clara Broncos', 'SCU Broncos'],
    SDAK: ['South Dakota Coyotes', 'SDAK Coyotes'],
    SDST: [
      'South Dakota State Jackrabbits',
      'S Dakota St',
      'S Dakota St Jackrabbits',
      'SDST Jackrabbits',
    ],
    SDSU: ['San Diego State Aztecs', 'SDSU Aztecs'],
    SEA: ['Seattle U Redhawks', 'SEA Redhawks'],
    SELA: ['SE Louisiana Lady Lions', 'SELA Lady Lions'],
    SEMO: [
      'Southeast Missouri State Redhawks',
      'SE Missouri',
      'SE Missouri Redhawks',
      'SEMO Redhawks',
    ],
    SF: ['San Francisco Dons', 'SF Dons'],
    SFA: ['Stephen F. Austin Ladyjacks', 'SF Austin', 'SF Austin Ladyjacks', 'SFA Ladyjacks'],
    SHSU: ['Sam Houston Bearkats', 'SHSU Bearkats'],
    SHU: ['Sacred Heart Pioneers', 'SHU Pioneers'],
    SIE: ['Siena Saints', 'SIE Saints'],
    SIU: ['Southern Illinois Salukis', 'S Illinois', 'S Illinois Salukis', 'SIU Salukis'],
    SIUE: ['SIU Edwardsville Cougars', 'SIUE Cougars'],
    SJSU: ['San José State Spartans', 'SJSU Spartans'],
    SJU: ["St. John's Red Storm", 'SJU Red Storm'],
    SLU: ['Saint Louis Billikens', 'SLU Billikens'],
    SMC: ["Saint Mary's Gaels", 'SMC Gaels'],
    SMU: ['SMU Mustangs'],
    SOU: ['Southern Jaguars', 'SOU Jaguars'],
    SPU: ["Saint Peter's Peacocks", 'SPU Peacocks'],
    STAN: ['Stanford Cardinal', 'STAN Cardinal'],
    STBK: ['Stony Brook Seawolves', 'STBK Seawolves'],
    STET: ['Stetson Hatters', 'STET Hatters'],
    STMN: ['St. Thomas Tommies', 'St Thomas', 'STMN Tommies'],
    STO: ['Stonehill Skyhawks', 'STO Skyhawks'],
    SUU: ['Southern Utah Thunderbirds', 'SUU Thunderbirds'],
    SYR: ['Syracuse Orange', 'SYR Orange'],
    'TA&M': ['Texas A&M Aggies', 'TA&M Aggies'],
    TAR: ['Tarleton State Texans', 'TAR Texans'],
    TCU: ['TCU Horned Frogs'],
    TEM: ['Temple Owls', 'TEM Owls'],
    TENN: ['Tennessee Lady Volunteers', 'TENN Lady Volunteers'],
    TEX: ['Texas Longhorns', 'TEX Longhorns'],
    TLSA: ['Tulsa Golden Hurricane', 'TLSA Golden Hurricane'],
    TNST: ['Tennessee State Lady Tigers', 'TNST Lady Tigers'],
    TNTC: ['Tennessee Tech Golden Eagles', 'TNTC Golden Eagles'],
    TOL: ['Toledo Rockets', 'TOL Rockets'],
    TOW: ['Towson Tigers', 'TOW Tigers'],
    TROY: ['Troy Trojans'],
    TTU: ['Texas Tech Lady Raiders', 'TTU Lady Raiders'],
    TULN: ['Tulane Green Wave', 'TULN Green Wave'],
    TXSO: ['Texas Southern Tigers', 'TXSO Tigers'],
    TXST: ['Texas State Bobcats', 'TXST Bobcats'],
    UAB: ['UAB Blazers'],
    UALB: ['UAlbany Great Danes', 'UALB Great Danes'],
    UAPB: [
      'Arkansas-Pine Bluff Golden Lions',
      'AR-Pine Bluff',
      'AR-Pine Bluff Golden Lions',
      'UAPB Golden Lions',
    ],
    UCD: ['UC Davis Aggies', 'UCD Aggies'],
    UCF: ['UCF Knights'],
    UCI: ['UC Irvine Anteaters', 'UCI Anteaters'],
    UCLA: ['UCLA Bruins'],
    UCR: ['UC Riverside Highlanders', 'UCR Highlanders'],
    UCSB: ['UC Santa Barbara Gauchos', 'Santa Barbara', 'Santa Barbara Gauchos', 'UCSB Gauchos'],
    UCSD: ['UC San Diego Tritons', 'UCSD Tritons'],
    UGA: ['Georgia Lady Bulldogs', 'UGA Lady Bulldogs'],
    UIC: ['UIC Flames'],
    UIW: ['Incarnate Word Cardinals', 'UIW Cardinals'],
    UK: ['Kentucky Wildcats', 'UK Wildcats'],
    UL: ["Louisiana Ragin' Cajuns", "UL Ragin' Cajuns"],
    ULM: ['UL Monroe Warhawks', 'ULM Warhawks'],
    UMBC: ['UMBC Retrievers'],
    UMES: ['Maryland Eastern Shore Hawks', 'MD Eastern', 'MD Eastern Hawks', 'UMES Hawks'],
    UML: ['UMass Lowell River Hawks', 'UML River Hawks'],
    UNA: ['North Alabama Lions', 'UNA Lions'],
    UNC: ['North Carolina Tar Heels', 'UNC Tar Heels'],
    UNCA: ['UNC Asheville Bulldogs', 'UNCA Bulldogs'],
    UNCG: ['UNC Greensboro Spartans', 'UNCG Spartans'],
    UNCO: ['Northern Colorado Bears', 'N Colorado', 'N Colorado Bears', 'UNCO Bears'],
    UNCW: ['UNC Wilmington Seahawks', 'UNCW Seahawks'],
    UND: ['North Dakota Fighting Hawks', 'UND Fighting Hawks'],
    UNF: ['North Florida Ospreys', 'UNF Ospreys'],
    UNH: ['New Hampshire Wildcats', 'UNH Wildcats'],
    UNI: ['Northern Iowa Panthers', 'UNI Panthers'],
    UNLV: ['UNLV Lady Rebels'],
    UNM: ['New Mexico Lobos', 'UNM Lobos'],
    UNO: [
      'LSU New Orleans Privateers',
      'NOLA',
      'LSU N Orleans',
      'LSU New Orleans',
      'LSU N Orleans Privateers',
      'NOLA Privateers',
    ],
    UNT: ['North Texas Mean Green', 'UNT Mean Green'],
    UPST: ['South Carolina Upstate Spartans', 'SC Upstate', 'SC Upstate Spartans', 'UPST Spartans'],
    URI: ['Rhode Island Rams', 'URI Rams'],
    USA: ['South Alabama Jaguars', 'USA Jaguars'],
    USC: ['USC Trojans'],
    USD: ['San Diego Toreros', 'USD Toreros'],
    USF: ['South Florida Bulls', 'USF Bulls'],
    USI: [
      'Southern Indiana Screaming Eagles',
      'S Indiana',
      'S Indiana Screaming Eagles',
      'USI Screaming Eagles',
    ],
    USM: ['Southern Miss Lady Eagles', 'USM Lady Eagles'],
    USU: ['Utah State Aggies', 'USU Aggies'],
    UTA: ['UT Arlington Mavericks', 'UTA Mavericks'],
    UTAH: ['Utah Utes'],
    UTC: ['Chattanooga Mocs', 'UTC Mocs'],
    UTEP: ['UTEP Miners'],
    UTM: ['UT Martin Skyhawks', 'UTM Skyhawks'],
    UTSA: ['UTSA Roadrunners'],
    UTU: ['Utah Tech Trailblazers', 'UTU Trailblazers'],
    UVA: ['Virginia Cavaliers', 'UVA Cavaliers'],
    UVM: ['Vermont Catamounts', 'UVM Catamounts'],
    UVU: ['Utah Valley Wolverines', 'UVU Wolverines'],
    VAL: ['Valparaiso Beacons', 'VAL Beacons'],
    VAN: ['Vanderbilt Commodores', 'VAN Commodores'],
    VCU: ['VCU Rams'],
    VILL: ['Villanova Wildcats', 'VILL Wildcats'],
    VT: ['Virginia Tech Hokies', 'VT Hokies'],
    'W&M': ['William & Mary Tribe', 'W&M Tribe'],
    WAG: ['Wagner Seahawks', 'WAG Seahawks'],
    WAKE: ['Wake Forest Demon Deacons', 'WAKE Demon Deacons'],
    WASH: ['Washington Huskies', 'WASH Huskies'],
    WCU: ['Western Carolina Catamounts', 'W Carolina', 'W Carolina Catamounts', 'WCU Catamounts'],
    WEB: ['Weber State Wildcats', 'WEB Wildcats'],
    WGA: ['West Georgia Wolves', 'WGA Wolves'],
    WICH: ['Wichita State Shockers', 'WICH Shockers'],
    WIN: ['Winthrop Eagles', 'WIN Eagles'],
    WIS: ['Wisconsin Badgers', 'WIS Badgers'],
    WIU: [
      'Western Illinois Leathernecks',
      'W Illinois',
      'W Illinois Leathernecks',
      'WIU Leathernecks',
    ],
    WKU: [
      'Western Kentucky Lady Toppers',
      'Western KY',
      'Western KY Lady Toppers',
      'WKU Lady Toppers',
    ],
    WMU: ['Western Michigan Broncos', 'W Michigan', 'W Michigan Broncos', 'WMU Broncos'],
    WOF: ['Wofford Terriers', 'WOF Terriers'],
    WRST: ['Wright State Raiders', 'WRST Raiders'],
    WSU: ['Washington State Cougars', 'WSU Cougars'],
    WVU: ['West Virginia Mountaineers', 'WVU Mountaineers'],
    WYO: ['Wyoming Cowgirls', 'WYO Cowgirls'],
    XAV: ['Xavier Musketeers', 'XAV Musketeers'],
    YALE: ['Yale Bulldogs'],
    YSU: ['Youngstown State Penguins', 'YSU Penguins'],
  },
};
